import { createContext, useContext } from 'react';
const LoopItemContext = /*#__PURE__*/createContext(null);
export const LoopItemProvider = LoopItemContext.Provider;
export function useLoopItem() {
  return useContext(LoopItemContext);
}